export const LOSS_AT_MATURITY = [
  { id: 'AT_MATURITY', displayValue: 'At Maturity' },
  { id: 'ON_CREDIT_EVENT', displayValue: 'On Credit Event' },
];
